import React from "react";
import { Button, Form, Input, message, Checkbox, Flex } from "antd";
import { QuestionCircleOutlined } from '@ant-design/icons';
import Captcha from "../../components/captcha";
import { openUrlExternally } from '../../utils/jsbridge';

const Regist = () => {
    const [form] = Form.useForm();
    const [imageUrl, setImageUrl] = React.useState();
    const [loading, setLoading] = React.useState(false);
    const [actionUrl, setActionUrl] = React.useState();
    const phoneNo = Form.useWatch('phoneNo', form);

    const onRegist = async () => {
        try {
            const url = new URL(window.location.href);
            const values = await form.validateFields();
            console.log("Success:", values);

            let response = await fetch(`/api/login/regist${url.search}`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(values),
            });

            let result = await response.json();

            if (result && result.success) {
                // message.success("注册成功！");
                setTimeout(() => {
                    window.location.href = `/regist2?accId=${result.data.accId}`;
                }, 500);
            } else {
                message.error(result.data);
            }

        } catch (errorInfo) {
            console.log("Failed:", errorInfo);
        }
    };

    return (
        <div className="flex items-center justify-center min-h-[calc(100vh-120px)]">
            <div>
                {/* 主内容区 */}
                <div className="w-full max-w-md bg-white shadow-xl rounded-2xl p-5 md:p-8 select-none">
                    <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6 text-center">注册优选到家</h2>
                        
                        <Form form={form} layout="vertical">
                            <Form.Item
                                label="手机号码"
                                name="phoneNo"
                                rules={[
                                    { required: true, message: "请输入手机号码" },
                                    { pattern: /^1[3456789]\d{9}$/, message: "请输入正确的手机号码" }
                                ]}
                                className="mb-0"
                            >
                                <Input 
                                    className="rounded-lg min-h-touch text-base" 
                                    placeholder="请输入手机号码" 
                                    type="tel"
                                    maxLength={11}
                                    size="large"
                                />
                            </Form.Item>

                            <Form.Item
                                label="短信验证码"
                                name="code"
                                rules={[{ required: true, message: "请输入验证码" }]}
                                className="mb-0"
                            >
                                <Captcha 
                                    phoneNo={phoneNo} 
                                    onSendCode={() => {
                                        console.log("验证码已发送");
                                    }}
                                />
                            </Form.Item>

                            <Form.Item
                                label=""
                                name='agree'
                                valuePropName="checked"
                                rules={[
                                    {
                                        validator: (_, value) =>
                                            value ? Promise.resolve() : Promise.reject(new Error('请阅读用户隐私协议和账户使用协议并同意'))
                                    }
                                ]}
                                className="mb-0"
                            >
                                <Checkbox id='agree' className="text-sm text-gray-600 min-h-touch flex items-center">
                                    <span>已阅读并同意</span>
                                    <a href='https://www.yxdj.tech/privacy-policy.html' className="text-blue-600 hover:text-blue-800 mx-1 active:opacity-70 transition-opacity">隐私政策</a>
                                    <span>和</span>
                                    <a href='https://www.yxdj.tech/account-usage-agreement.html' className="text-blue-600 hover:text-blue-800 mx-1 active:opacity-70 transition-opacity">账户使用协议</a>
                                </Checkbox>
                            </Form.Item>
                        </Form>

                        <div className="flex gap-3 mt-6 mb-4">
                            <Button 
                                onClick={() => window.location.href = '/login'} 
                                type='default' 
                                className="flex-1 rounded-lg min-h-touch text-base font-medium bg-white hover:bg-gray-50 active:scale-95 transition-transform border-gray-300"
                                size="large"
                            >
                                返回登录
                            </Button>
                            <Button 
                                type='primary' 
                                onClick={onRegist} 
                                className="flex-1 rounded-lg min-h-touch text-base font-medium bg-blue-600 hover:bg-blue-700 border-blue-600 active:scale-95 transition-transform"
                                size="large"
                            >
                                下一步
                            </Button>
                        </div>
                        
                        {/* 辅助链接 */}
                        <Flex className="mt-4 text-sm" align='center' justify='end' gap={2}>
                            <a 
                                onClick={() => openUrlExternally('https://www.yxdj.tech/')} 
                                className="text-gray-600 hover:text-blue-600 transition-colors min-h-touch flex items-center active:opacity-70"
                            >
                                <QuestionCircleOutlined className="mr-1" /> 了解优选到家
                            </a>
                        </Flex>
                </div>
                
                {/* 底部版权信息 */}
                <p className="px-4 py-3 text-center text-xs text-gray-500 safe-bottom">
                    ©{new Date().getFullYear()}{' '}
                    <a 
                        onClick={() => openUrlExternally('https://www.yxdj.tech/')} 
                        className="hover:text-blue-600 transition-colors active:opacity-70"
                    >
                        杭州优选到家科技有限公司
                    </a>{' '}
                    版权所有<br />
                    浙ICP备2025162413号-3
                </p>
            </div>
        </div>
    );    
};

export default Regist;